import { render, staticRenderFns } from "./expressPickupService.vue?vue&type=template&id=58717659"
import script from "./expressPickupService.vue?vue&type=script&lang=js"
export * from "./expressPickupService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports